import React, { Children, PropsWithChildren, ReactElement } from 'react'
import { INavItemProps } from '../../../../../../shared/components/cards/nav-item/NavItem'

type NavItem = ReactElement<PropsWithChildren<INavItemProps>>

export interface INavMenuProps {
  children?: NavItem | NavItem[]
}

export const NavMenu = ({ children }: INavMenuProps) => {
  return (
    <ul className='flex list-none justify-center last:mr-0'>
      {Children.map(children, (child) => {
        return <li className={child?.props.hidden ? 'mr-0' : 'mr-[32px]'}>{child}</li>
      })}
    </ul>
  )
}
